/* eslint-disable */
<template>
	<div id="strategylist">
		<div class="middle">
			<div class="module">
				<div style="">
					<van-list :style="listStyle" v-model="loading" :finished="finished1"
						:error.sync="error" error-text="请求失败，点击重新加载" @load="onLoad">
						<div v-for="(item, index) in goodList" :key="index" class="card-item good-card-item"
							@click="showDetail(item.id)">
							<div class="topName">
								<div class="name-inner">
									{{ item.name }}
									<span class="subscribe-count">{{ item.subscribers }}人订阅</span>
								</div>
								<van-icon name="arrow" class="card-arrow" />
							</div>
							<div class="income-data">
								<div class="annual-income">
									<p class="income-label">年化收益</p>
									<p class="income-value">{{ item.annualizedReturn }}</p>
								</div>
								<div class="total-income">
									<p class="income-label">累计收益</p>
									<p class="income-value">{{ item.totalReturn }}
									</p>
								</div>
                <div class="total-income">
                  <p class="income-label">开始时间</p>
                  <p class="income-value">{{ item.startDate }}
                  </p>
                </div>
							</div>
						</div>
					</van-list>
				</div>
			</div>
		</div>
		<icp-info :isFixed="true" />
		<div class="bottom">
			<the-tabbar active-page="teacher" />
		</div>
	</div>
</template>
<script>
import TheTabbar from '@/components/theTabbar.vue'
import * as sysTools from '@/utils/sysTools'
import {
	List,
	Tabbar,
	TabbarItem,
	Icon,
	Tab,
	Dialog,
	Tag,
	DropdownMenu,
	DropdownItem
} from 'vant'

import { fetchStrategylist, islogin, logout, fetchGoodStrategylistV3, fetchAllStrategylist } from '@/api/theApi'
import flagicon from '@/icons/png/flagIcon-1.png'
import IcpInfo from '@/components/IcpInfo.vue'
export default {
	components: {
		[List.name]: List,
		[Tabbar.name]: Tabbar,
		[TabbarItem.name]: TabbarItem,
		[Icon.name]: Icon,
		[Tab.name]: Tab,
		[Tag.name]: Tag,
		[DropdownMenu.name]: DropdownMenu,
		[DropdownItem.name]: DropdownItem,
		TheTabbar,
		IcpInfo,
	},
	data() {
		return {
			flagicon: flagicon,
			list: [],
			goodList: [],
			loading: true,
			error: false,
			finished: false,
			finished1: false,
			filter1value: 0,
			filter1index: 0,
			filter2value: 0,
			listall: [],
			subscriberCounts: {},

			filter1option: [{
				text: '适用资金(默认)',
				value: 0,
				index: 0,
				min: 0,
				max: 1000
			},
			{
				text: '2万-10万',
				value: 1,
				index: 1,
				min: 2,
				max: 10
			},
			{
				text: '10万-30万',
				value: 2,
				index: 2,
				min: 10,
				max: 30
			},
			{
				text: '30万-60万',
				value: 3,
				index: 3,
				min: 30,
				max: 60
			},
			{
				text: '60万-100万',
				value: 4,
				index: 4,
				min: 60,
				max: 100
			}
				// {
				//   text: '150万以上',
				//   value: 150
				// }
			],
			// filter2option: [{
			// 		text: '累计收益率',
			// 		value: 0
			// 	},
			// 	{
			// 		text: '年化回报率',
			// 		value: 1
			// 	},
			// 	{
			// 		text: '夏普比率',
			// 		value: 2
			// 	},
			// 	{
			// 		text: '日收益率',
			// 		value: 3
			// 	}
			// ],
			filterV: 1,
			filter2option: [{
				text: '升序',
				value: 'asc'
			},
			{
				text: '降序',
				value: 'desc'
			}
			],
			filterTotal: 'asc',
			filter20: 'asc',
			filter120: 'asc',
			filterDraw: 'asc',
			unlogin: false
		}
	},
	computed: {
		// 检测是否在微信环境中
		isWeiXin() {
			const ua = sysTools.getUA();
			return ua.indexOf('micromessenger') !== -1;
		},
		// 根据微信环境动态设置van-list样式
		listStyle() {
			const baseStyle = {
				padding: '8px 16px'
			};
			
			// 在微信环境中设置margin-top为8px，否则为38px
			baseStyle.marginTop = this.isWeiXin ? '8px' : '38px';
			
			return baseStyle;
		}
	},
	created() {
		this.init()
	},
	methods: {
		async init() {
			const res = await fetchAllStrategylist({
				pageNum: 1,
				pageSize: 10000,
				direction: 'desc',
				orderBy: 'annualized_return'
			})
			const resData = res.data
			const goodRes = await fetchGoodStrategylistV3()
			const goodResData = goodRes.data

			// 创建优选策略ID集合，用于快速查找
			const goodStrategyIds = new Set(goodResData.map(item => item.strategyId));

			// 初始化订阅人数映射
			this.subscriberCounts = {};
			resData.forEach((item, index) => {
				// 如果是优选策略，乘以100，否则乘以50
				const multiplier = goodStrategyIds.has(item.strategyId) ? 100 : 50;
				this.subscriberCounts[item.strategyId] = item.strategyId + (15 - index) * multiplier;
			});

			// 设置优选策略列表，使用相同的订阅人数
			this.goodList = goodResData.map(item => ({
				...item,
				subscriberCount: this.subscriberCounts[item.strategyId] || 0
			}));

			// 设置全部策略列表，使用相同的订阅人数
			this.list = resData.map(item => ({
				...item,
				subscriberCount: this.subscriberCounts[item.strategyId] || 0
			}));

			this.listall = resData;
			this.filter2value = 0;
			this.loading = false;
			this.finished = true;
			this.finished1 = true;
			const isloginRes = await islogin()
			const username = localStorage.getItem('username')

			if (isloginRes.login_status && username) {
				// Toast.loading('已经登陆')
				// const b64u = Base64.encode(username)
				this.unlogin = false
			} else {
				// localStorage.clear()
				this.unlogin = true
			}

			if (!isloginRes.login_status && username) {
				this.unlogin = true

				localStorage.clear()
			}

			if (isloginRes.login_status && !username) {
				this.unlogin = true

				// Toast.fail('登录过期\n请重新登陆')
				logout().then(() => { })
			}
		},
		onLoad() {
			// 异步更新数据
			setTimeout(() => {
				// 获取数据push数据
				// 加载状态结束
				this.loading = false
				// 数据全部加载完成
				if (this.list.length >= 1) {
					this.finished = true
					this.finished1 = true
				}
			}, 500)
		},
		showDetail(startegy_id) {
			// console.log(startegy_id)
			const targeturl = '/strategy/detail/' + startegy_id
			this.$router.push({
				path: targeturl
			})
		},
		gotologin() {
			this.$router.push({
				path: '/login'
			})
		},
		async checkMenu(a, b, c) {
			if (this.filterV === a) {
				this.filterV = b;
			} else {
				this.filterV = a;
			}
			this.finished = false;
			const res = await fetchAllStrategylist({
				pageNum: 1,
				pageSize: 10000,
				direction: this.filterV % 2 !== 0 ? 'desc' : 'asc',
				orderBy: c
			})
			const resData = res.data
			let rsltData = []
			resData.forEach(element => {
				rsltData = rsltData.concat(element)
			})
			this.list = rsltData.sort((a, b) => {
				return b - a
			})
			this.listall = rsltData
			this.finished = true;
		},
		showTip(type) {
			let msg = '';
			if (type === 1) {
				msg = '最大回撤率是衡量投顾风险的重要指标。表示任意时点使用此投顾往后推，资金总额走到最低点时的收益率回撤幅度的最大值，可理解为熊市最多亏多少。';
			} else {
				msg = '夏普比率是衡量在每承担1个单位风险的情况下，所获得的回报率是多少。夏普比率越高，说明投资的性价比越高、收益越高风险越小。';
			}
			// Notify({ type: 'warning', message: msg});
			Dialog.alert({
				title: '提示',
				message: msg,
			}).then(() => {
				// on close
			});
		},
		filter1change() {
			// console.log(this.filter1value)

			// console.log(this.filter1option[this.filter1value].min)
			// console.log(this.filter1option[this.filter1value].max)
			// console.log(this.filter1option[this.filter1value])

			const min = this.filter1option[this.filter1value].min
			const max = this.filter1option[this.filter1value].max

			// 数据更替
			this.list = this.listall.filter(item => {
				const itemvalue = parseInt(item.applicable_funds.split('万')[0])
				return itemvalue >= min && itemvalue <= max
			})
		},
		filter2change() {
			if (this.filter2value === 0) {
				this.list = this.listall.sort((a, b) => {
					// console.log(a.total_return.replace('%', '') - b.total_return.replace('%', ''))
					return (
						parseFloat(b.total_return && b.total_return.replace('%', '')) -
						parseFloat(a.total_return && a.total_return.replace('%', ''))
					)
				})
			}
			if (this.filter2value === 1) {

				this.list = this.listall.sort((a, b) => {
					return (
						parseFloat(b.annualized_return && b.annualized_return.replace('%', '')) -
						parseFloat(a.annualized_return && a.annualized_return.replace('%', ''))
					)
				})
			}
			if (this.filter2value === 2) {
				this.list = this.listall.sort((a, b) => {
					return (
						parseFloat(b.sharp_value && b.sharp_value.replace('%', '')) -
						parseFloat(a.sharp_value && a.sharp_value.replace('%', ''))
					)
				})
			}
			if (this.filter2value === 3) {
				this.list = this.listall.sort((a, b) => {
					return (
						parseFloat(b.daily_return && b.daily_return.replace('%', '')) -
						parseFloat(a.daily_return && a.daily_return.replace('%', ''))
					)
				})
			}
			// 数据更替
		}
	}
}
</script>
<style lang="less" scoped>
#homev2 {
	position: relative;
	height: 100vh;
	width: 100vw;
	// display: flex;
	// flex-direction: column;
}

#strategylist {
	width: 100%;
	// height: 100%;
}

.top {
	// bottom: 4rem;
	top: 0;
	// height:3.5rem;
	position: fixed;
	height: 7.5vh;
	z-index: 1;
	width: 100vw;
	background: rgba(255, 255, 255, 1);
	box-shadow: 0px 0px 9px 1px rgba(0, 0, 0, 0.18);

	.logo {
		width: 42vw;
		// height: 5vh;
		margin-left: 3.4vw;
		margin-top: 1.2vh;
	}

	.button {
		width: 18vw;
		float: right;
		height: 9vw;
		margin-right: 3.5vw;
		margin-top: 1.7vh;
	}
}

.titleMenu {
	padding: 15px 0;
	padding-top: 0;
	background-color: white;
	font-size: 4vw;
	display: flex;
	justify-content: space-between;
}

.titleMenuItem {
	width: 23%;
	margin: 0 1%;
	text-align: center;
	position: relative;
}

.titleMenuItem span {

	position: relative;
}

.titleMenuItem span::before {
	position: absolute;
	content: '';
	top: 2px;
	right: -13px;
	border-bottom: 5px solid rgb(220, 220, 220);
	border-right: 6px solid transparent;
	border-left: 6px solid transparent;
}

.titleMenuItem span::after {
	position: absolute;
	content: '';
	bottom: 2px;
	right: -13px;
	border-top: 5px solid rgb(220, 220, 220);
	border-right: 6px solid transparent;
	border-left: 6px solid transparent;
}

.titleMenuItem.desc.active span::after {
	border-top-color: #1989fa;
}

.titleMenuItem.asc.active span::before {

	border-bottom-color: #1989fa;
}

.middle {
	bottom: 7.5vh;
	// top: 7.5vh;
	top: 0;
	// height: 15rem;
	position: absolute;
	background-color: #f5f5f5;
	width: 100vw;
	padding-bottom: 70px; /* 为底部tabbar留出空间 */

	.login {
		width: 100vw;
		margin-top: 55.5vh;
	}

	.reg {
		margin-top: -1.7vh;
		width: 90.3vw;
		margin-left: 4.8vw;
	}

	.list-item {
		display: flex;

		div {
			position: absolute;
		}
	}

	.card-item {
		background-color: #ffffff;
		margin: 0 auto;
		position: relative;

		.recommend-img {
			width: 7vh;
			height: 7vh;
			float: right;
		}

		.title {
			position: absolute;
			top: 3vh;
			left: 4vw;
			font-size: 5vw;
			height: 4vw;
			font-weight: bold;
		}

		.accumulate {
			position: absolute;
			top: 4vh;
			right: 30vw;
			font-size: 3vw;
			font-weight: 700;
			font-stretch: normal;
			letter-spacing: 0vw;
			color: #000000;
		}

		.valuea {
			position: absolute;
			top: 2.3vh;
			right: 4.2vw;

			font-size: 5.5vw;
			font-family: sans-serif;
			font-weight: bold;
			line-height: 2rem;
			color: rgba(255, 64, 64, 1)
		}

		.middleline {
			position: absolute;
			top: 7vh;
			left: 3vw;
			padding: 1vh;
			background-color: #f5f5f5;
			border-radius: 1vw;
			display: inline-flex;

			.marginright15 {
				margin-right: 2vw;
			}

			.key {
				color: rgba(102, 102, 102, 1);
				font-size: 3vw;
			}

			// hello teset
			.valuer {
				margin-left: 8px;
				color: rgba(255, 52, 52, 1);
				font-size: 3vw;

			}

			.valueg {
				margin-left: 8px;
				font-size: 3vw;
				color: rgba(61, 171, 31, 1)
			}
		}

		.bottomline {
			// position: absolute;
			// top: 12.5vh;
			// left:10vw;
			// height: 1.8vh;
			width: 90vw;
			// display: inline-flex;

			.formoney {
				// color: rgba(255, 64, 64, 1);
				// font-weight: bold;
				// line-height: 4.5vw;
				// font-size: 3vw;
				margin-top: 1vh;
				margin-left: 7vw;
				padding: 1vh 2vw;
				background-color: #fff0f0;
				border-radius: 1vh;
				font-size: 3vw;
				color: #ff4040;
			}

			.see {
				height: 3vw;
				font-size: 3vw;
				letter-spacing: 0vw;
				color: #666666;
				// margin: auto 0 auto 5vw;
			}

			.fund {
				position: absolute;
				top: 1vh;
				left: 2vw;
				display: block;
				width: 7vw;
				height: 7vw;
			}
		}
	}

	.good-card-item {
		margin-top: 8px;
		width: 100%;
		height: auto;
		padding: 16px;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		border-radius: 8px;
	}

	.subscribe-count {
		font-size: 12px;
		color: #493726;
		margin-left: 10px;
		display: inline-block;
		background-color: #FFF2D9;
		padding: 2px 8px;
		border-radius: 4px;
		font-weight: 400;
	}

	.income-data {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 16px;
		position: relative;
	}

	.annual-income,
	.total-income {
		width: 45%;
	}

	.income-label {
		font-size: 12px;
		color: #8E8E93;
		margin-bottom: 3px;
	}

	.income-value {
		font-size: 16px;
		line-height: 1.5;
		font-weight: 700;
		color: #000000;
	}

	.card-arrow {
		color: #999;
		font-size: 16px;
	}
}

.topName {
	width: 100%;
	font-size: 16px;
	font-weight: bold;
	display: flex;
	align-items: center;
	justify-content: space-between;

	.name-inner {
		font-weight: bold;
	}
}

.bottomData {
	margin-top: 1vh;
	display: flex;

	.left {
		width: 37%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		.key {
			font-size: 0.9rem;
			margin-top: 2vh;
			color: rgb(140, 140, 140);
		}

		.valuer {
			font-size: 1.25rem;
			color: #000000;
		}
	}

	.right {
		width: 19%;
		margin: 0 1%;
		height: 100%;
		text-align: center;
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		.key {
			font-size: 0.618rem;
			margin-top: 2vh;
			color: rgb(140, 140, 140);
		}

		.valuer {
			font-size: 1rem;
			color: rgb(60, 60, 60);
		}
	}
}

.bottom {
	bottom: 0;
	height: 50px;
	position: fixed;
	width: 100%;
	z-index: 999;
}

.moduleTitle {
	text-align: center;
	padding: 15px 4vw;
	background-color: white;
	font-weight: bold;
	font-size: 5.5vw;
}
</style>